module.exports = __webpack_public_path__ + "img/ABOUT US.3f674477.png";